/*====== import  ======*/
/*------ React ------*/
import React, { useEffect } from "react"
import { useNavigate } from 'react-router-dom';
import {  TOKEN_STORAGE } from "03CommonApiParts/CodeDefinition";
/*------ CSS ------*/
// import styled from 'styled-components';
/*------ Component Js/Jsx ------*/
import axios from "axios";
import { LoadingProgressBar } from "02CommonUiParts/OtherParts/LoadingProgressBar";
import { cognitoAuthorization, cognitoClientId, cognitoRedirectURI, cognitoURL } from "03CommonApiParts/authConfig";
/*====== Styles  ======*/
/*------ Styled Components ------*/

/*====== global variables ======*/

/*====== global functions ======*/


/* --------------------------- */
/* ---------- main ---------- */
/* --------------------------- */
export const AUTHCT = () =>{ //cognito Token取得
    
    /* --------------------------- */
    /* -------- instance  -------- */
    /* --------------------------- */
    const navigate = useNavigate();//画面遷移用
    /* --------------------------- */
    /* ---------- state ---------- */
    /* --------------------------- */

    /* --------------------------- */
    /* -------- variables -------- */
    /* --------------------------- */
    /* Reactメモリから遷移情報取得 */
    const token = sessionStorage.getItem(TOKEN_STORAGE);
    var tokenValue = JSON.parse(token);//JSON 文字列を取得し、JavaScriptオブジェクトに変換
    /*------- urlからパラメータ取得 ------*/
    var url = new URL(window.top.location.href);
    const params = url.searchParams;

    /* --------------------------- */
    /* -------- functions -------- */
    /* --------------------------- */
    useEffect(()=>{
        postCognitoToken();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    /* cognito token取得 */
    const postCognitoToken = async() =>{
        const url = cognitoURL;    
        const clientId = cognitoClientId;
        const redirectUri = cognitoRedirectURI;
        const code = params.get('code');
        const body = `grant_type=authorization_code&client_id=${clientId}&redirect_uri=${redirectUri}&code=${code}`
        const option = {
            headers:{
                'Content-Type':'application/x-www-form-urlencoded',
                'Authorization':cognitoAuthorization
            }
        }
        await axios.post(url,body,option)
        .then((res)=>{
            const data = res.data;
            const token = {
                ...tokenValue,
                id:data.id_token,
                refresh:data.refresh_token,
            }
            sessionStorage.setItem(TOKEN_STORAGE,JSON.stringify(token));
            navigate('/common/auth02');

        })
        .catch((e)=>{
            // console.log(e);
        })
        
    };

    /* --------------------------- */
    /* ---------- data ----------- */
    /* --------------------------- */
	
    
    return(
        <>
            <LoadingProgressBar open={true}/>
        </>
    );
}